import { type DestinationItem, ExpandableDestinationList } from './ExpandableDestinationList';

type InternalLinksSectionProps = {
    title: string;
    titleId: string;
    items: DestinationItem[];
};

export const InternalLinksSection = ({ title, titleId, items }: InternalLinksSectionProps) => (
    <section className="mb-32 px-16" aria-labelledby={titleId}>
        <h3 id={titleId} className="mb-16">
            {title}
        </h3>
        <div className="flex flex-col md:flex-row md:gap-24 gap-16">
            {[0, 1, 2].map((col) => (
                <div key={col} className="flex-1 flex flex-col gap-16">
                    {items
                        .filter((_, i) => i % 3 === col)
                        .map((item) => (
                            <ExpandableDestinationList key={item.title} {...item} />
                        ))}
                </div>
            ))}
        </div>
    </section>
);
